import Link from 'next/link'

export const Custom404 = ({ title = 'Page Not Found' }: { title?: string }) => {
  return (
    <div className="mt-[30px] flex flex-col items-center justify-center flex-1">
      <h1 className="text-3xl md:text-4xl font-semibold leading-tight gradient-text text-center mb-4">
        Ethena: Enabling Internet Money
      </h1>
      <h5 className="text-white text-center mb-32">Ethena is a digital dollar protocol for the internet economy.</h5>
      <p className="text-white text-center">{title}</p>
      <div className="flex flex-col gap-2 sm:flex-row justify-center items-center mt-6">
        <Link
          href="/"
          className="block text-base rounded-lg py-2 px-10 bg-white hover:bg-neutral-200 transition-colors duration-200 text-neutral-950 font-bold text-center w-fit"
        >
          Back to Home
        </Link>
      </div>
    </div>
  )
}
